import { Menu } from 'antd';
import React, { useEffect, useState } from 'react';

const ContextMenu = ({ x, y, showMenu, path }) => {

    const onClick = (e) => {
        e.domEvent.preventDefault(); // Prevent default link behavior
        e.domEvent.stopPropagation(); // Prevent further propagation
        const baseURL = `${window.location.protocol}//${window.location.host}`
        const uniqueTarget = `_blank${Date.now()}`;
        window.open(`${baseURL}${path}`, uniqueTarget, 'noopener,noreferrer');
    };

    const items = [{ key: '1', label: 'Open in new Tab' }];

    return (
        showMenu && (
            <Menu
                onClick={onClick}
                style={{
                    position: "fixed",
                    top: y,
                    left: x,
                    boxShadow: '1px 1px 4px 1px #E0E0E0',
                    borderRadius: '8px',
                    zIndex: 1000
                }}
                items={items}
                getPopupContainer={(node) => node.parentNode}
            />
        )
    );
};

export const SidebarContextMenu = ({ children, path, ...rest }) => {
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const [showMenu, setShowMenu] = useState(false);

  const handleRightClick = (event) => {
    event.preventDefault(); // Prevent the default right-click menu
    setMenuPosition({ x: event.pageX, y: event.pageY });
    setShowMenu(true);
  };

  const handleClickOutside = () => {
    setShowMenu(false);
  };

  useEffect(() => {
    // Hide the menu on a click outside or window resize
    window.addEventListener("click", handleClickOutside);
    window.addEventListener("resize", handleClickOutside);

    return () => {
      window.removeEventListener("click", handleClickOutside);
      window.removeEventListener("resize", handleClickOutside);
    };
  }, []);

  return (
    <>
        <div onContextMenu={handleRightClick}>
            {children}
        </div>
        <ContextMenu
            x={menuPosition.x}
            y={menuPosition.y}
            showMenu={showMenu}
            path={path}
            onClose={handleClickOutside}
        />
    </>
  );
}

